import { SettingsRow } from './ui/settings-row'
import { UnifiedButton } from './ui/unified-button'

interface DataSourceToggleProps {
  dataSource: 'api' | 'csv'
  onDataSourceChange: (source: 'api' | 'csv') => void
  title?: string
  description?: string
}

export const DataSourceToggle = ({
  dataSource,
  onDataSourceChange,
  title = 'Data Source',
  description = 'Choose how to import your workout data from Hevy'
}: DataSourceToggleProps) => {
  return (
    <SettingsRow
      title={title}
      description={description}
      action={
        <div className="bg-muted/50 flex w-full items-stretch gap-1 rounded-lg p-1">
          <UnifiedButton
            variant={dataSource === 'api' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onDataSourceChange('api')}
            className="flex-1 justify-center px-3"
          >
            <div
              className={`mr-1.5 h-2 w-2 flex-shrink-0 rounded-full ${
                dataSource === 'api' ? 'bg-green-500' : 'bg-muted-foreground/30'
              }`}
            />
            Live Sync
          </UnifiedButton>
          <UnifiedButton
            variant={dataSource === 'csv' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onDataSourceChange('csv')}
            className="flex-1 justify-center px-3 text-nowrap"
          >
            <div
              className={`mr-1.5 h-2 w-2 flex-shrink-0 rounded-full${
                dataSource === 'csv' ? 'bg-blue-500' : 'bg-muted-foreground'
              }`}
            />
            File Import
          </UnifiedButton>
        </div>
      }
    />
  )
}
